// extracted by mini-css-extract-plugin
export default {"content_wrapper":"client-application-settings-page_content_wrapper__PBDI9"};